import { render } from "./PreTestForm.vue?vue&type=template&id=55427684&scoped=true"
import script from "./PreTestForm.vue?vue&type=script&lang=js"
export * from "./PreTestForm.vue?vue&type=script&lang=js"

import "./PreTestForm.vue?vue&type=style&index=0&id=55427684&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55427684"]])

export default __exports__